import { Button } from '@cimplico/components';
import { ArrowUpCircleIcon } from '@heroicons/react/24/outline';
import { LockClosedIcon } from '@heroicons/react/24/solid';
import { useNavigate } from 'react-router-dom';
import { useFirmContext } from '../../providers/FirmProvider';
import { useUserFirmRoleContext } from '../../providers/UserFirmRoleProvider';
import { UserRoleEnum } from '../../types/user';
import InsightImage from '../../assets/firm-insights.png';

function FirmInsightsPreview(): JSX.Element {
    const navigate = useNavigate();
    const { shortId } = useFirmContext();
    const role = useUserFirmRoleContext();

    return (
        <div className="relative">
            <div className="flex flex-col justify-center items-center absolute z-40 top-1/4 right-1/2 translate-x-1/2 translate-y-1/2 bg-white/90 py-4 px-6 rounded-md shadow-md w-[70%]">
                <LockClosedIcon className="h-6 w-6 text-gray-600" />
                <p className="text-gray-600 mb-2 text-center">
                    Upgrade to the <b>Essential</b> or <b>Professional</b> plan to access this feature
                </p>
                <Button
                    type="primary"
                    size="sm"
                    label="Upgrade"
                    leftIcon={<ArrowUpCircleIcon />}
                    onClick={(): void => {
                        navigate(`/${shortId}/settings`);
                    }}
                    disabled={role !== UserRoleEnum.ADMIN}
                />
                {role !== UserRoleEnum.ADMIN && (
                    <p className="text-gray-600 mt-2 text-sm">To upgrade, please contact your firm&apos;s administrator</p>
                )}
            </div>
            <div>
                <img src={InsightImage} className="blur-[4px]" />
            </div>
        </div>
    );
}

export default FirmInsightsPreview;
